/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, {
  useEffect, useState, useRef,
} from 'react';
import moment from 'moment';
import {
  Card, Form, Menu, Row, Spin, Tabs, message, Modal, Divider, Button, Col, DatePicker, notification, Progress,
} from 'antd';
import {
  UserOutlined,
  InfoCircleOutlined,
  EnvironmentOutlined,
  FileTextOutlined,
  PhoneOutlined,
  CalendarOutlined,
  CreditCardOutlined,
  SolutionOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  DollarOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  TeamOutlined,
  CameraOutlined,
  AuditOutlined,
  EditOutlined,
} from '@ant-design/icons';
import { formatReceived, formatReceivedValues } from 'utils/formatValues';
import { areaBuscar, normalizeData } from 'utils/normalizers';
import {
  CURP_PATTERN, digitoVerificador, RFC_PATTERN, SLUG_PATTERN, NOMBRES_PATTERN_GENERICO,
} from 'utils/patterns';
import { onAlert, onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import useSeguimientoDeRegistro from 'hooks/useSeguimientoDeRegistro';
import ModalDelete from 'components/ModalDelete';
import {
  getContentTypesUR, getEstados, getMunicipio, getAreas, getCodigosPostales, getTiposDeEmpleados,
} from 'api/catalogos';
import { getPaises } from 'api/catalogos/paises';
import { getEstadosDeEmpleados } from 'api/estructuraOrganizacional/estadosDeEmpleados';
import { getTiposDeMovimientoDePersonal } from 'api/catalogos/tiposDeMovimientoDePersonal';
import { getEstadosCiviles, getGeneros } from 'api/usuarios';
import { getPuestos } from 'api/estructuraOrganizacional/puestos';
import { getTiemposDeContrataciones } from 'api/catalogos/tiemposDeContrataciones';
import { getJornadas } from 'api/catalogos/jornadas';
import { getTiposDeSueldos } from 'api/catalogos/tiposDeSueldos';
import { getSindicatos } from 'api/catalogos/sindicatos';
import { getPeriodicidadesDePagos } from 'api/catalogos/periodicidadesDePagos';
import { getZonasDeSalariosMinimos } from 'api/catalogos/zonasDeSalariosMinimos';
import { getTiposRegimenesNominas } from 'api/catalogos/tiposRegimenesNominas';
import { getTiposDeIdentificaciones } from 'api/catalogos/tiposDeIdentificaciones';
import { getTiposDeSeguridadesSociales } from 'api/catalogos/tiposDeSeguridadesSociales';
import { getRegistrosPatronales } from 'api/catalogos/registrosPatronales';
import { getNivelesDeEstudios } from 'api/catalogos/nivelesDeEstudios';
import { getAbreviaturasDeCarreras } from 'api/catalogos/abreviaturasDeCarreras';
import { getComprobantesDeEstudios } from 'api/catalogos/comprobantesDeEstudios';
import { getEspecialidadesDeEstudios } from 'api/catalogos/especialidadesDeEstudios';
import { getNacionalidades } from 'api/catalogos/nacionalidades';
import { getPlaza, getPlazas } from 'api/catalogos/plazas';
import { getCategoriasDePuestos } from 'api/catalogos/categoriaDePuestos';
import { getTabuladoresGenerales } from 'api/nominas/tabuladores/tabuladoresGenerales';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import { getAdministracionDePlazas } from 'api/catalogos/admnistracionDePlazas';
import { getMetodosDePagos } from 'api/catalogos/metodosDePagos';
import { getBancos } from 'api/configuraciones/bancos';
import { getTiposDeDepositos } from 'api/catalogos/tiposDeDepositos';

import {
  deleteEmpleado,
  getEmpleado,
  getEmpleados,
  patchEmpleado,
  postEmpleado,
  descargarExcelEmpleados,
  getEmpleadosvistaOptimized,
  getEmpleadosExportarCompleto,
} from 'api/estructuraOrganizacional/empleados';
import {
  deleteDatoOperacionalDelEmpleado,
  getDatoOperacionalesDeEmpleados,
  patchDatoOperacionalDelEmpleado,
  postDatoOperacionalDelEmpleados,
} from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
import { getDatosDePagoDeEmpleados } from 'api/estructuraOrganizacional/datosDePagoDeEmpleados';
import { checkToken } from 'api/utils';
import EmpleadoGeneral from 'components/Catalogos/Empleado/General';
import EmpleadoFiliacion from 'components/Catalogos/Empleado/Filiacion';
import EmpleadoAdscripcion from 'components/Catalogos/Empleado/Adscripcion';
import EmpleadoAtributos from 'components/Catalogos/Empleado/Atributos';
import EmpleadoDireccion from 'components/Catalogos/Empleado/Direccion';
import Otros from 'components/Catalogos/Empleado/Otros';
// import EmpleadoOtrosDatos from 'components/Catalogos/Empleado/OtrosDatos';
import EmpleadoEstudios from 'components/Catalogos/Empleado/Estudios';
import EmpleadoContacto from 'components/Catalogos/Empleado/Contacto';
import EmpleadoFormaPago, { empleadoFormaPagoPermission } from 'components/Catalogos/Empleado/FormaPago';
import { getTiposDeFunciones } from 'api/catalogos/tiposDeFunciones';
import Documentos, { documentoEmpleadoPermission } from 'components/Catalogos/Empleado/Documentos';
import Sindicato, { historicoDeSindicatoPermission } from 'components/Catalogos/Empleado/Sindicato';
import KardexSBC, { kardexSBCEmpleadoPermission } from 'components/Catalogos/Empleado/KardexSBC';
import NombramientosEmpleado, { nombramientosEmpleadoPermission } from 'components/Catalogos/Empleado/NombramientosEmpleado';
import { getModelPermission } from 'utils/permission';
import { getTiposDeContrataciones } from 'api/catalogos/tiposDeContrataciones';
import {
  ESTADO_ACTIVO,
  ESTADO_BAJA,
  ESTADO_PRE_ALTA,
  ESTADO_REINGRESO,
  ESTADO_SUSPENDIDO,
  ESTATUS_AUTORIZADO,
  ESTATUS_CANCELADO,
} from 'utils/constants';
import { getCaracteresDeNombramiento } from 'api/catalogos/CaracterDeNombramiento';
import { getNombramientosSinPaginar } from 'api/catalogos/Nombramientos';
import { getPreferenciaSPartidarias } from 'api/catalogos/PreferenciaPartidaria';
import Direccion from 'components/Direccion';
import Direcciones from 'components/Catalogos/Empleado/Direccion2';
import { getTiposDeActividades } from 'api/catalogos/TiposDeActividades';
import { getTiposDeOrigenesDeContratacion } from 'api/catalogos/tiposDeOrigenesDeContratacion';
import EmpleadoDatosPresupuestales from 'components/Catalogos/Empleado/DatosPresupuestales';
import currencyFormatter from 'utils/currencyFormatter';
import CurrencyInput from 'components/CurrencyInput';
import ModalConfirmation from 'components/ModalConfirmation';
import ExportadorExcelPersonalizado from 'components/ExportadorExcelPersonalizado';
import {
  getHistoricoSBCEmpleado,
  postHistoricoSBCEmpleado,
  patchHistoricoSBCEmpleado,
  deleteHistoricoSBCEmpleado,
  descargarPlantillaSBC,
  importarSBCEmpleado,
} from 'api/estructuraOrganizacional/historicoSBCEmpleado';
import DireccionGeneral from 'components/Catalogos/Empleado/DireccionGeneral';
import getProcesoEnCursoTerminado from 'api/catalogos/ProcesoEnCursoTerminado';
import {
  postActualizarFotosEnigmaSuite,
  postDetenerFotosEnigmaSuite,
  DESCRIPCION_PROCESO_SINCRONIZAR_FOTOS,
} from 'api/estructuraOrganizacional/empleadosSincronizarFotos';
// import DatosDePago from 'components/Catalogos/DatosDePago';
//   EmpleadoGeneral,
//   EmpleadoFiliacion,
//   EmpleadoAdscripcion,
//   Otros,
//   EmpleadoFormaPago,
//   Documentos,
// });
const { TabPane } = Tabs;
const baseURI = 'estructura-organizacional/empleados';
const baseURIExtra = 'catalogos/dato-operacional-del-empleado';

export const onErrorFields = (
  err,
  setLoading = null,
  formsInstances = [],
  setCurrentTabKey,
  setCurrentTabKeyDO,
  setCurrentParentTabKey,
) => {
  if (typeof setLoading === 'function') {
    setLoading(false);
  }
  const errorKeys = err.errorFields.map((e) => e.name[0]);
  const formWithErrors = formsInstances.find(
    (obj) => obj.tabFields.some(
      (val) => errorKeys.includes(val),
    ),
  );
  if (formWithErrors) {
    setTimeout(() => {
      if (typeof setCurrentTabKey === 'function') {
        switch (formWithErrors.parentTabKey) {
          case 'operativos':
            setCurrentTabKeyDO(formWithErrors.tabKey);
            break;
          case 'pago':
            break;
          default:
            setCurrentTabKey(formWithErrors.tabKey);
        }
        setCurrentParentTabKey(formWithErrors.parentTabKey);
      }
    });
  }
};

export const empleadosPermission = {
  permissionModel: 'empleado',
  catalogsModels: [
    'estadodelempleado',
    'genero',
    'estadocivil',
    'puesto',
    'centrodecostos',
    'formadepago',
  ],
};

const Empleados = ({ permission }) => {
  const [form] = Form.useForm();
  const [formFiliacion] = Form.useForm();
  const [formOperacionales] = Form.useForm();
  const [formDireccion] = Form.useForm();
  const [formPlazas] = Form.useForm();
  const [formPago] = Form.useForm();

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estadosEmpleado, setEstadosDeEmpleado] = useState([]);
  const [tiposDeMovimientoDePersonal, setTiposDeMovimientoDePersonal] = useState([]);
  const [puestos, setPuestos] = useState([]);
  const [metodosDePagos, setMetodosDePagos] = useState([]);
  const [bancos, setBancos] = useState([]);
  const [tiposDeDepositos, setTiposDeDepositos] = useState([]);
  const [paises, setPaises] = useState([]);
  const [estados, setEstados] = useState([]);
  const [generos, setGeneros] = useState([]);
  const [tiemposDeContrataciones, setTiemposDeContrataciones] = useState([]);
  const [jornadas, setJornadas] = useState([]);
  const [tiposDeSueldos, setTiposDeSueldos] = useState([]);
  const [sindicatos, setSindicatos] = useState([]);
  const [periodicidadesDePagos, setPeriodicidadesDePagos] = useState([]);
  const [zonasDeSalariosMinimos, setZonasDeSalariosMinimos] = useState([]);
  const [tiposRegimenesNominas, setTiposRegimenesNominas] = useState([]);
  const [tiposDeIdentificaciones, setTiposDeIdentificaciones] = useState([]);
  const [tiposDeSeguridadesSociales, setTiposDeSeguridadesSociales] = useState([]);
  const [registrosPatronales, setRegistrosPatronales] = useState([]);
  const [nivelesDeEstudios, setNivelesDeEstudios] = useState([]);
  const [abreviaturasDeCarreras, setAbreviaturasDeCarreras] = useState([]);
  const [comprobantesDeEstudios, setComprobantesDeEstudios] = useState([]);
  const [especialidadesDeEstudios, setEspecialidadesDeEstudios] = useState([]);
  const [nacionalidades, setNacionalidades] = useState([]);
  const [estadoCivil, setEstadoCivil] = useState([]);
  const [currentTabKey, setCurrentTabKey] = useState('general');
  const [currentTabKeyDO, setCurrentTabKeyDO] = useState('adscripcion');
  const [currentParentTabKey, setCurrentParentTabKey] = useState('general');
  const [contentTypes, setContentTypes] = useState([]);
  const [administracionDePlazas, setAdministracionDePlazas] = useState([]);
  const [areas, setAreas] = useState([]);
  const [categoriaDePuestos, setCategoriaDePuestos] = useState([]);
  const [tabuladoresGenerales, setTabuladoresGenerales] = useState([]);
  const [tiposDeNominasEmpleados, setTiposDeNominasEmpleados] = useState([]);
  const [datosOperacionales, setDatosOperacionales] = useState([]);
  // const [datosPago, setDatosPago] = useState([]);
  const [coloniasCargadas, setColoniasCargadas] = useState([]);
  const [tiposDeFunciones, setTiposDeFunciones] = useState([]);
  const [tiposDeContrataciones, setTiposDeContrataciones] = useState([]);
  const [empleadoId, setEmpleadoId] = useState();
  const [fechaDeAlta, setFechaDeAlta] = useState({});
  const [fechaDeBaja, setFechaDeBaja] = useState({});
  const [fechaDeReingreso, setFechaDeReingreso] = useState({});
  const [nombreEmpleadoEditar, setNombreEmpleadoEditar] = useState([]);
  const [apellidoPEmpleadoEditar, setApellidoPEmpleadoEditar] = useState([]);
  const [apellidoMEmpleadoEditar, setApellidoMEmpleadoEditar] = useState([]);
  const [numEmpleadoEditar, setNumEmpleadoEditar] = useState();
  const [disableEstatus, setDisableEstatus] = useState(true);
  const [plazas, setPlazas] = useState([]);
  const [isBlocked, setIsBlocked] = useState(false);
  const [editandoAutorizado, setEditandoAutorizado] = useState(false);
  const [nominaDisplay, setNominaDisplay] = useState();
  const [tiposEmpleados, setTiposEmpleados] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [cuipHabilitado, setCuipHabilitado] = useState(false);
  const [caracteresDeNombramiento, setCaracteresDeNombramiento] = useState([]);
  const [nombramientosSinPaginar, setNombramientosSinPaginar] = useState([]);
  const [plazaEmpleado, setPlazaEmpleado] = useState({});
  const [codigosPostales, setCodigosPostales] = useState([]);
  const [preferenciaPartidaria, setPreferenciaPartidaria] = useState([]);
  const [fullData, setFullData] = useState([]);
  const [tipoDeActividad, setTipoDeActividad] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [progress, setProgress] = useState(0);
  const [loadingTime, setLoadingTime] = useState(0); // en segundos
  const [startTime, setStartTime] = useState(null);
  const [tiposOrigenesContratacion, setTiposOrigenesContratacion] = useState([]);
  const [origenContratacionSeleccionado, setOrigenContratacionSeleccionado] = useState(null);

  const [showExportador, setShowExportador] = useState(false);
  // Excel Personalizado: todos los campos de todas las pestañas (se consulta al abrir)
  const [datosExportador, setDatosExportador] = useState([]);
  const [titulosExportador, setTitulosExportador] = useState({});

  // Historial SBC Empleado
  const [formHistorialSBC] = Form.useForm();
  const [historialSBC, setHistorialSBC] = useState([]);
  const [selectedHistorialSBCKeys, setSelectedHistorialSBCKeys] = useState([]);
  const [historialSBCSeleccionado, setHistorialSBCSeleccionado] = useState(null);
  const [visibleHistorialSBCModal, setVisibleHistorialSBCModal] = useState(false);
  const [visibleDeleteHistorialSBC, setVisibleDeleteHistorialSBC] = useState(false);
  const [visibleConfirmAutorizarSBC, setVisibleConfirmAutorizarSBC] = useState(false);
  const [visibleConfirmCancelarSBC, setVisibleConfirmCancelarSBC] = useState(false);

  // Sincronizar Fotografías de Empleados (EnigmaSuite)
  const [visibleConfirmActualizarFotos, setVisibleConfirmActualizarFotos] = useState(false);
  const [isPollingActualizarFotos, setIsPollingActualizarFotos] = useState(false);
  const [progresoActualizarFotos, setProgresoActualizarFotos] = useState({ en_curso: 0, total: 0 });
  const pollingActualizarFotosRef = useRef(null);
  const [loadingDetenerFotos, setLoadingDetenerFotos] = useState(false);
  const [minimizadoFotos, setMinimizadoFotos] = useState(false);

  // REGLAS DE VALIDACIÓN – movidas aquí para que estén disponibles en todo el componente
  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const validadorSoloLetras = async (rule, value) => {
    const isValid = /^[a-zA-ZñÑáÁéÉíÍóÓúÚ]+(?: [a-zA-ZñÑáÁéÉíÍóÓúÚ]+)*$/.test(value);
    if (!isValid && value.length > 0) {
      throw new Error('Ingrese solo letras');
    }
  };

  const rules = {
    required: [requiredRule],
    lada: [requiredRule],
    numero_de_telefono: [requiredRule],
    clave: [
      requiredRule,
      {
        pattern: SLUG_PATTERN,
        message: 'Ingrese un número de empleado válido',
      },
    ],
    RFC: [
      requiredRule,
      {
        pattern: RFC_PATTERN,
        message: 'Ingrese un RFC válido',
      },
    ],
    curp: [
      requiredRule,
      {
        validator: async (rule, value) => {
          if (value) {
            const validado = value.toUpperCase().match(CURP_PATTERN);
            if (!validado || validado[2] !== digitoVerificador(validado[1])) {
              throw new Error('Ingrese una CURP válida');
            }
          }
        },
      },
    ],
    fecha_de_nacimiento: [
      requiredRule,
      {
        validator: async (rule, value) => {
          const fechaFuturo = (Date.now() - value);
          const ageDate = new Date(fechaFuturo);
          const ageNum = (ageDate.getUTCFullYear() - 1970);
          if (fechaFuturo < 0) {
            throw new Error('Introduzca una fecha válida');
          } else if (ageNum < 16) {
            throw new Error('No se permiten empleados menores de 16 años');
          } else if (ageNum > 100) {
            throw new Error('No se permiten empleados mayores de 100 años');
          }
        },
      },
    ],
    solo_numeros_enteros: [
      {
        validator: async (rule, value) => {
          if (value) {
            const numeroEnteroBooleano = (/^\d+$/.test(value));
            const cantidadDeCaracteres = value.length;
            if ((!numeroEnteroBooleano) && (cantidadDeCaracteres > 0)) {
              throw new Error('Ingrese un número válido');
            }
          }
        },
      },
    ],
    sueldo_diario: [
      requiredRule,
      {
        validator: async (rule, value) => {
          if (value) {
            const isValidNumber = /^\d+(\.\d{1,2})?$/.test(value);
            if (!isValidNumber) {
              throw new Error('Ingrese un número válido con máximo dos decimales');
            }
          }
        },
      },
    ],
    telefono: [
      {
        validator: async (rule, value) => {
          if (value) {
            const numeroEnteroBooleano = /^\d+$/.test(value);
            const cantidadDeCaracteres = value.length;
            if (!numeroEnteroBooleano || cantidadDeCaracteres !== 10) {
              throw new Error('Ingrese un número válido de 10 dígitos');
            }
          }
        },
      },
    ],
    no_identificacion: [
      requiredRule,
      {
        validator: async (rule, value) => {
          if (value) {
            const numeroEnteroBooleano = /^\d+$/.test(value);
            const cantidadDeCaracteres = value.length;
            if (!numeroEnteroBooleano || cantidadDeCaracteres !== 11) {
              throw new Error('Ingrese un número válido de 11 dígitos');
            }
          }
        },
      },
    ],
    no_cedula_profesional: [
      {
        validator: async (rule, value) => {
          if (value) {
            const numeroEnteroBooleano = /^\d+$/.test(value);
            const cantidadDeCaracteres = value.length;
            if (!numeroEnteroBooleano || cantidadDeCaracteres > 10) {
              throw new Error('Ingrese un número válido menor a 10 dígitos');
            }
          }
        },
      },
    ],
    correo_electronico: [
      requiredRule,
      {
        type: 'email',
        message: 'Ingrese un correo válido',
      },
    ],
    fecha_de_alta: [
      requiredRule,
      {
        validator: async (rule, value) => {
          if (fechaDeBaja) {
            if (value > fechaDeBaja) {
              throw new Error('La Fecha de Alta no puede ser mayor que la Fecha de Baja');
            }
          }
        },
      },
    ],
    fecha_de_baja: [
      {
        validator: async (rule, value) => {
          if (value) {
            if (fechaDeAlta > value) {
              throw new Error('La Fecha de Baja no puede ser menor a la Fecha de Alta');
            }
            if (fechaDeReingreso) {
              if (fechaDeReingreso < value) {
                throw new Error('La Fecha de Baja no puede ser mayor que la Fecha de Reingreso');
              }
            }
          }
        },
      },
    ],
    fecha_de_reingreso: [
      {
        validator: async (rule, value) => {
          if (value) {
            if (fechaDeBaja) {
              if (fechaDeBaja > value) {
                throw new Error('La Fecha de Reingreso no puede ser menor que la Fecha De Baja');
              }
            }
          }
        },
      },
    ],
    entero_requerido: [
      requiredRule,
      {
        validator: async (rule, value) => {
          const isInteger = /^\d+$/.test(value);
          if (!isInteger && value?.length > 0) {
            throw new Error('Ingrese un número válido');
          }
        },
      },
    ],
    numero_de_seguridad_social: [
      {
        validator: async (rule, value) => {
          const isValid = /^\d{11}$/.test(value);
          if (!isValid) {
            throw new Error('Ingrese un número de 11 dígitos');
          }
        },
      },
    ],
    solo_letras_requerido: [
      requiredRule,
      {
        validator: validadorSoloLetras,
      },
    ],
    solo_letras: [
      {
        validator: validadorSoloLetras,
      },
    ],
    nombre: [
      requiredRule,
      {
        pattern: NOMBRES_PATTERN_GENERICO,
        message: 'Ingrese un nombre válido',
      },
    ],
    numero_tarjeta: [
      {
        validator: async (rule, value) => {
          const soloNumeros = /^\d+$/.test(value);
          const longitud = value?.length;
          if (!value || longitud < 1) return;
          if (!soloNumeros) {
            throw new Error('Solo se permiten números.');
          }
          if (longitud < 8 || longitud > 16) {
            throw new Error('El valor debe ser entre 8 y 16 dígitos.');
          }
        },
      },
    ],
    CLABE: [
      {
        validator: async (rule, value) => {
          const numeroEnteroBooleano = (/^\d+$/.test(value));
          if (value?.length < 1 || !value) return;
          if (!numeroEnteroBooleano) {
            throw new Error('Solo se permiten números.');
          }
          if (value?.length !== 18) {
            throw new Error('El valor debe ser de 18 dígitos.');
          }
        },
      },
    ],
  };

  const getPermission = getModelPermission(
    documentoEmpleadoPermission.permissionModel,
    documentoEmpleadoPermission.catalogsModels,
    documentoEmpleadoPermission.tabsModels,
    empleadoFormaPagoPermission.permissionModel,
    empleadoFormaPagoPermission.catalogsModels,
    empleadoFormaPagoPermission.tabsModels,
    false,
  );

  const sindicatoPermission = getModelPermission(
    historicoDeSindicatoPermission.permissionModel,
    historicoDeSindicatoPermission.catalogsModels,
    historicoDeSindicatoPermission.tabsModels,
    false,
  );

  const nombramientosEmpleadoPermission_ = getModelPermission(
    nombramientosEmpleadoPermission.permissionModel,
    nombramientosEmpleadoPermission.catalogsModels,
    nombramientosEmpleadoPermission.tabsModels,
    false,
  );

  const kardexSBCEmpleadoPermission_ = getModelPermission(
    kardexSBCEmpleadoPermission.permissionModel,
    kardexSBCEmpleadoPermission.catalogsModels,
    kardexSBCEmpleadoPermission.tabsModels,
    false,
  );

  const formatReceivedClone = (values) => {
    if (Array.isArray(values)) {
      let valueClone = values.map((e) => formatReceivedValues(e));
      valueClone = valueClone.map((e) => ({
        ...e,
        puesto: e?.id,
        tipoDeNominaEmpleado: e?.id,
        area: e?.id,
        plaza: e?.id,
      }));
      return valueClone;
    }
    return formatReceivedValues(values);
  };

  // Estos son unicamente los campos requeridos de cada tab.
  const requiredFormStructure = [
    {
      parentTabKey: 'general',
      tabKey: 'general',
      tabFields: ['numero_de_empleado', 'nombre', 'apellido_paterno',
        'appelido_materno', 'genero', 'nacionalidad', 'pais', 'estado',
        'lugar_de_nacimiento', 'fecha_de_nacimiento', 'estado_civil', 'tipo_sangre',
        'tiene_hijos', 'estado_del_empleado'],
    },
    {
      parentTabKey: 'general',
      tabKey: 'filiacion',
      tabFields: ['tipo_de_identificacion', 'numero_de_identificacion', 'numero_de_seguridad_social', 'RFC', 'curp',
        'codigo_postal_fiscal_texto_libre'],
    },
    {
      parentTabKey: 'general',
      tabKey: 'direccion',
      tabFields: ['codigo_postal', 'colonia', 'tipo_de_vialidad', 'calle_principal'],
    },
    {
      parentTabKey: 'general',
      tabKey: 'contacto',
      tabFields: ['numero_de_telefono', 'numero_de_celular',
        'contacto_de_emergencia', 'correo_electronico'],
    },
    {
      parentTabKey: 'operativos',
      tabKey: 'adscripcion',
      tabFields: ['fecha_de_alta', 'unidad_responsable', 'puesto'],
    },
    {
      parentTabKey: 'operativos',
      tabKey: 'atributos',
      tabFields: ['tipo_de_contratacion', 'tiempo_de_contratacion', 'jornada', 'tipo_de_sueldo',
        'tipo_regimen_nomina', 'periodicidad_de_pago', 'sindicato', 'zona_de_salario_minimo',
        'aplica_firma_electronica', 'aplica_resguardo_activo_fijo'],
    },
    {
      parentTabKey: 'pago',
      tabKey: 'pago',
      tabFields: ['metodo_de_pago'],
    },
    {
      parentTabKey: 'documentos',
      tabKey: 'documentos',
      tabFields: ['documentos'],
    },
    {
      parentTabKey: 'operativos',
      tabKey: 'datos_presupuestales',
      tabFields: ['campo_requerido_1', 'campo_requerido_2'],
    },
  ];

  const fetchData = async () => {
    setLoading(true);
    const _data = await getEmpleadosvistaOptimized();
    const ordenados = formatReceived(_data)
      .sort((a, b) => Number(a.numero_de_empleado) - Number(b.numero_de_empleado));
    setFullData(ordenados);
    setData(ordenados);
    setLoading(false);
  };

  const onConfirmActualizarFotos = async () => {
    setVisibleConfirmActualizarFotos(false);
    setProgresoActualizarFotos({ en_curso: 0, total: 0 });
    const resultado = await postActualizarFotosEnigmaSuite();
    if (resultado?.descripcion) {
      setIsPollingActualizarFotos(true);
    }
  };

  const onClickDetenerActualizarFotos = async () => {
    setLoadingDetenerFotos(true);
    await postDetenerFotosEnigmaSuite();
    setLoadingDetenerFotos(false);
  };

  // Al montar: si ya hay una actualización de fotografías corriendo en segundo
  // plano (por ejemplo, disparada antes de recargar la página), reengancha el
  // polling y el aviso de progreso en vez de dejarlo invisible.
  useEffect(() => {
    let mounted = true;
    const revisarProcesoEnCurso = async () => {
      const lista = await getProcesoEnCursoTerminado({
        descripcion: DESCRIPCION_PROCESO_SINCRONIZAR_FOTOS,
      });
      const proceso = lista[0];
      if (mounted && proceso?.procesando) {
        const progreso = {
          en_curso: proceso.registro_en_curso || 0,
          total: proceso.total_registros || 0,
        };
        setProgresoActualizarFotos(progreso);
        setIsPollingActualizarFotos(true);
      }
    };
    revisarProcesoEnCurso();
    return () => { mounted = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isPollingActualizarFotos) return undefined;
    let intentos = 0;
    const maxIntentos = 340; // ~11 min

    pollingActualizarFotosRef.current = setInterval(async () => {
      try {
        intentos += 1;
        const lista = await getProcesoEnCursoTerminado({
          descripcion: DESCRIPCION_PROCESO_SINCRONIZAR_FOTOS,
        });
        const proceso = lista[0];

        if (proceso) {
          const progreso = {
            en_curso: proceso.registro_en_curso || 0,
            total: proceso.total_registros || 0,
          };
          setProgresoActualizarFotos(progreso);
        }

        const termino = proceso && proceso.procesando === false;
        if (termino || intentos >= maxIntentos) {
          clearInterval(pollingActualizarFotosRef.current);
          pollingActualizarFotosRef.current = null;
          setIsPollingActualizarFotos(false);
          setMinimizadoFotos(false);
          setProgresoActualizarFotos({ en_curso: 0, total: 0 });

          if (termino) {
            notification.success({
              message: 'Actualización de fotografías completada',
              description: proceso.mensaje
                || `Las fotografías de ${proceso.registro_en_curso || 0} empleado(s) se actualizaron correctamente.`,
              placement: 'topRight',
              duration: 6,
            });
            await fetchData();
          } else {
            notification.warning({
              message: 'La actualización sigue en curso',
              description: 'Sigue procesándose en segundo plano; vuelve a revisar en unos minutos.',
              placement: 'topRight',
            });
          }
        }
      } catch (_err) {
        // No se interrumpe el polling: el siguiente tick reintenta. Si el
        // error es por sesión expirada, utils/api.js ya avisó y cerró
        // sesión; aquí solo dejamos rastro para diagnóstico.
        // eslint-disable-next-line no-console
        console.error('[polling sincronización de fotos] error al consultar estado', _err);
      }
    }, 2000);

    return () => {
      if (pollingActualizarFotosRef.current) {
        clearInterval(pollingActualizarFotosRef.current);
        pollingActualizarFotosRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPollingActualizarFotos]);

  const calcularEdad = (birthday) => {
    const ageDifMs = Date.now() - birthday;
    const ageDate = new Date(ageDifMs);
    const ageNum = (ageDate.getUTCFullYear() - 1970);
    if (Math.sign(ageNum) === -1) {
      return 0;
    }
    return ageNum;
  };

  const calcularAntiguedad = (fechaRegistro) => {
    const fechaDiferencia = Date.now() - fechaRegistro;
    const fechaNueva = new Date(fechaDiferencia);
    const fechaAnual = (fechaNueva.getUTCFullYear() - 1970);
    const fechaMes = (fechaNueva.getUTCMonth());
    if ((Math.sign(fechaAnual) === -1) || (Number.isNaN(fechaAnual))) {
      return 0;
    }
    return `${fechaAnual} ${(fechaAnual === 1 ? 'año' : 'años')} ${fechaMes} ${(fechaMes === 1 ? 'mes' : 'meses')}`;
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      const start = Date.now();
      setLoading(true);
      try {
        await checkToken();

        const [
          _tiposDeActividades,
          _estadosDeEmpleados,
          _tiposDeMovimientoDePersonal,
          _paises,
          _estados,
          _generos,
          _estadosCiviles,
          _puestos,
          _metodosDePagos,
          _bancos,
          _tiposDeDepositos,
          _tiemposDeContrataciones,
          _jornadas,
          _tiposDeSueldos,
          _sindicatos,
          _periodicidadesDePagos,
          _zonasDeSalariosMinimos,
          _tiposRegimenesNominas,
          _tiposDeIdentificaciones,
          _tiposDeSeguridadesSociales,
          _tiposDeFunciones,
          _tiposDeContrataciones,
          _registrosPatronales,
          _nivelesDeEstudios,
          _abreviaturasDeCarreras,
          _comprobantesDeEstudios,
          _especialidadesDeEstudios,
          _nacionalidades,
          _data,
          _preferenciaPartidaria,
          _tiposOrigenesContratacion,
          _areas,
        ] = await Promise.all([
          getTiposDeActividades(),
          getEstadosDeEmpleados(),
          getTiposDeMovimientoDePersonal({ estados_globales: ESTATUS_AUTORIZADO, modelo_origen: 'EMPLEADO' }),
          getPaises(),
          getEstados(),
          getGeneros(),
          getEstadosCiviles(),
          getPuestos(),
          getMetodosDePagos(),
          getBancos(),
          getTiposDeDepositos(),
          getTiemposDeContrataciones(),
          getJornadas({ estados_globales: ESTATUS_AUTORIZADO }),
          getTiposDeSueldos(),
          getSindicatos({ estados_globales: ESTATUS_AUTORIZADO }),
          getPeriodicidadesDePagos({ estados_globales: ESTATUS_AUTORIZADO }),
          getZonasDeSalariosMinimos({ estados_globales: ESTATUS_AUTORIZADO }),
          getTiposRegimenesNominas(),
          getTiposDeIdentificaciones({ estados_globales: ESTATUS_AUTORIZADO }),
          getTiposDeSeguridadesSociales({ estados_globales: ESTATUS_AUTORIZADO }),
          getTiposDeFunciones({ estados_globales: ESTATUS_AUTORIZADO }),
          getTiposDeContrataciones({ estados_globales: ESTATUS_AUTORIZADO }),
          getRegistrosPatronales(),
          getNivelesDeEstudios({ estados_globales: ESTATUS_AUTORIZADO }),
          getAbreviaturasDeCarreras({ estados_globales: ESTATUS_AUTORIZADO }),
          getComprobantesDeEstudios({ estados_globales: ESTATUS_AUTORIZADO }),
          getEspecialidadesDeEstudios({ estados_globales: ESTATUS_AUTORIZADO }),
          getNacionalidades(),
          getEmpleadosvistaOptimized(),
          getPreferenciaSPartidarias(),
          getTiposDeOrigenesDeContratacion(),
          getAreas({ estados_globales: ESTATUS_AUTORIZADO }),
        ]);

        if (mounted) {
          setTipoDeActividad(_tiposDeActividades);
          setEstadosDeEmpleado(_estadosDeEmpleados);
          setTiposDeMovimientoDePersonal(_tiposDeMovimientoDePersonal);
          setPaises(_paises);
          setEstados(_estados);
          setGeneros(_generos);
          setEstadoCivil(_estadosCiviles);
          setPuestos(_puestos);
          setMetodosDePagos(_metodosDePagos);
          setBancos(_bancos);
          setTiposDeDepositos(_tiposDeDepositos);
          setTiemposDeContrataciones(_tiemposDeContrataciones);
          setJornadas(_jornadas);
          setTiposDeSueldos(_tiposDeSueldos);
          setSindicatos(_sindicatos);
          setPeriodicidadesDePagos(_periodicidadesDePagos);
          setZonasDeSalariosMinimos(_zonasDeSalariosMinimos);
          setTiposRegimenesNominas(_tiposRegimenesNominas);
          setTiposDeIdentificaciones(_tiposDeIdentificaciones);
          setTiposDeSeguridadesSociales(_tiposDeSeguridadesSociales);
          setTiposDeFunciones(_tiposDeFunciones);
          setAreas(_areas);
          setTiposDeContrataciones(_tiposDeContrataciones);
          setRegistrosPatronales(_registrosPatronales);
          setNivelesDeEstudios(_nivelesDeEstudios);
          setAbreviaturasDeCarreras(_abreviaturasDeCarreras);
          setComprobantesDeEstudios(_comprobantesDeEstudios);
          setEspecialidadesDeEstudios(_especialidadesDeEstudios);
          setNacionalidades(_nacionalidades);

          const empleados = formatReceivedClone(_data)
            .sort((a, b) => Number(a.numero_de_empleado) - Number(b.numero_de_empleado));
          setFullData(empleados);
          setData({ count: empleados.length, results: empleados.slice(0, pagination.pageSize) });
          setPagination({
            current: 1,
            pageSize: 10,
            total: empleados.length,
          });

          setPreferenciaPartidaria(_preferenciaPartidaria);
          setTiposOrigenesContratacion(_tiposOrigenesContratacion);
          setLoading(false);

          const end = Date.now();
          const elapsed = (end - start) / 1000;
          setLoadingTime(elapsed.toFixed(2));
        }
      } catch (e) {
        const end = Date.now();
        const elapsed = (end - start) / 1000;
        setLoadingTime(elapsed.toFixed(2));
        setLoading(false);
      }
    };

    fetchAll();
    return () => { mounted = false; };
  }, []);

  const handleTableChange = (page, pageSize) => {
    const start = (page - 1) * pageSize;
    const end = start + pageSize;
    const paginated = fullData.slice(start, end);

    setData({ count: fullData.length, results: paginated });
    setPagination({
      current: page,
      pageSize,
      total: fullData.length,
    });
  };

  const onCancelWithFetch = () => {
    fetchData();
    setSelectedRowKeys([]);
    setEmpleadoId();
    setCurrentTabKey('general');
    setCurrentTabKeyDO('adscripcion');
    setCurrentParentTabKey('general');
    setData({ results: [] });
    setVisible(false);
    setOrigenContratacionSeleccionado(null);
    setEditandoAutorizado(false);
  };

  const onCancel = () => {
    // Limpiamos los nombres del header
    setNombreEmpleadoEditar('');
    setApellidoPEmpleadoEditar('');
    setApellidoMEmpleadoEditar('');
    setNumEmpleadoEditar();

    setSelectedRowKeys([]);
    setVisible(false);

    form.resetFields();
    formFiliacion.resetFields();
    formOperacionales.resetFields();
    formDireccion.resetFields();
    formPlazas.resetFields();
    formPago.resetFields();

    setCurrentTabKey('general');
    setCurrentTabKeyDO('adscripcion');
    setCurrentParentTabKey('general');
    setEmpleadoId();
    setNominaDisplay();
    setIsBlocked(false);
    setEditandoAutorizado(false);
    setCuipHabilitado(false);
  };

  const getURValuesToSend = () => {
    const unidad_responsable = formOperacionales.getFieldValue('unidad_responsable');
    if (unidad_responsable) {
      const [unidad_organizacional_id, nivel] = unidad_responsable.split('/');
      const content_de_unidad_organizacional = contentTypes.find((ct) => ct.nivel.toString() === nivel).id;
      return { unidad_organizacional_id, content_de_unidad_organizacional };
    }
    return { object_id: undefined, content_type: undefined };
  };

  const onClickEdit = async (responseData = null) => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      const match = responseData || fullData.find((item) => item.id === key);
      const _empleado = await getEmpleado(match.id);

      if (_empleado.numero_de_empleado) {
        setNumEmpleadoEditar(_empleado.numero_de_empleado);
      }
      if (_empleado.nombre) {
        setNombreEmpleadoEditar(_empleado.nombre);
      }
      if (_empleado.apellido_paterno) {
        setApellidoPEmpleadoEditar(_empleado.apellido_paterno);
      }
      if (_empleado.apellido_materno) {
        setApellidoMEmpleadoEditar(_empleado.apellido_materno);
      } else {
        setApellidoMEmpleadoEditar('');
      }
      setTimeout(() => {
        if (_empleado) {
          setEmpleadoId(_empleado?.id);
          form.resetFields();
          formOperacionales.resetFields();
          formDireccion.resetFields();
          formPlazas.resetFields();
          setOrigenContratacionSeleccionado(_empleado.tipo_de_origen_de_contratacion);
          setTimeout(async () => {
            if (_empleado.lugar_de_nacimiento) {
              const _municipio = await getMunicipio(_empleado.lugar_de_nacimiento);
              _empleado.estado = _municipio.estado.id;
            }
            _empleado.estado_nacimiento = _empleado.estado;

            form.setFieldsValue(formatReceivedClone(_empleado));
            // comisionado_en_area_externa / area_externa_de_comision viven en Empleado,
            // pero su Form.Item esta registrado en formPlazas (tarjeta "Comision en Area
            // Externa" de Adscripcion.jsx) -- se setean aqui explicitamente porque
            // Adscripcion.jsx ya NO los sobreescribe desde DatoOperacionalDelEmpleado
            // (ese modelo no tiene estos campos; ver CLAUDE.md).
            formPlazas.setFieldsValue({
              comisionado_en_area_externa: _empleado.comisionado_en_area_externa || false,
              area_externa_de_comision: _empleado.area_externa_de_comision || null,
              comisionado_en_area_interna: _empleado.comisionado_en_area_interna || false,
              directorio_de_area_comisionado_area_interna: _empleado.directorio_de_area_comisionado_area_interna || null,
            });
            formFiliacion.setFieldsValue({
              RFC: _empleado.RFC || null,
              curp: _empleado.curp || null,
              tipo_de_identificacion: _empleado.tipo_de_identificacion ?? null,
              numero_de_identificacion: _empleado.numero_de_identificacion ?? null,
              tipo_de_seguridad_social: _empleado.tipo_de_seguridad_social ?? null,
              numero_de_seguridad_social: _empleado.numero_de_seguridad_social ?? null,
              registro_patronal: _empleado.registro_patronal ?? null,
              salario_base_cotizacion_imss: _empleado.salario_base_cotizacion_imss ?? null,
              salario_base_cotizacion_imms: _empleado.salario_base_cotizacion_imss ?? null,
            });
            form.setFieldsValue({
              preferencia_partidaria: _empleado.preferencia_partidaria ?? null,
            });
            if (_empleado.codigo_postal_fiscal_texto_libre) {
              formFiliacion.setFieldsValue({
                codigo_postal: null,
                codigo_postal_fiscal_texto_libre: _empleado.codigo_postal_fiscal_texto_libre,
              });
            }
            const _estatus = form.getFieldValue('estado_del_empleado');
            const _adminPlaza = await getAdministracionDePlazas({ empleado: _empleado.id });

            // Forzamos a que siempre esté bloqueado
            setDisableEstatus(true);

            form.setFieldsValue({
              edad: calcularEdad(form.getFieldValue('fecha_de_nacimiento')),
            });

            const datoOpEmp = await getDatoOperacionalesDeEmpleados({ empleado: _empleado.id });
            if (datoOpEmp.length > 0) {
              formOperacionales.setFieldsValue(formatReceived(datoOpEmp[0]));
              const fechaRegistro = datoOpEmp[0]?.fecha_de_alta;
              if (fechaRegistro) {
                formOperacionales.setFieldsValue({
                  antiguedad: calcularAntiguedad(fechaRegistro),
                });
              }
              const tipoFuncionId = datoOpEmp[0]?.tipo_de_funcion;
              if (tipoFuncionId) {
                setCuipHabilitado(tipoFuncionId === 'Seguridad Pública');
              }
            } else {
              formOperacionales.resetFields();
            }

            const datoPagoEmp = await getDatosDePagoDeEmpleados({ empleado: _empleado.id });

            if (datoPagoEmp.length > 0) {
              formPago.setFieldsValue(formatReceived(datoPagoEmp[0]));
            }

            if (_adminPlaza.length > 0) {
              const _dataPlazaEmp = await getPlaza(_adminPlaza[0].plaza);

              if (_dataPlazaEmp) {
                setPlazaEmpleado(_dataPlazaEmp);
                formPlazas.setFieldsValue(formatReceived(_dataPlazaEmp));
              }
            }
            setVisible(true);
          });
        }
      });
      setLoading(false);
    } catch (error) {
      onError(error);
      setLoading(false);
    }
  };

  const onFinish = async (_values, _continue = true) => {
    try {
      setLoading(true);

      await form.validateFields();
      await formFiliacion.validateFields();

      form.setFieldsValue({
        edad: calcularEdad(form.getFieldValue('fecha_de_nacimiento')),
      });

      const values = {
        ...form.getFieldsValue(),
        ...formFiliacion.getFieldsValue(),
        ...formOperacionales.getFieldsValue(),
        ...formPlazas.getFieldsValue(),
      };

      values.codigo_postal = null;

      const [empleadoObj] = selectedRowKeys;

      const saved = await (empleadoObj ? patchEmpleado(empleadoObj, values) : postEmpleado(values));

      if (saved) {
        onSuccess({}, ` ${selectedRowKeys ? 'Editado' : 'Agregado'} exitosamente.`);
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          await onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      if (err.errorFields) {
        onErrorFields(
          err,
          setLoading,
          requiredFormStructure,
          setCurrentTabKey,
          setCurrentTabKeyDO,
          setCurrentParentTabKey,
        );
        message.warn('Favor de corregir los errores señalados');
      }
      setLoading(false);
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteEmpleado(key);
        if (deleted) {
          const datoOpEmp = await getDatoOperacionalesDeEmpleados({ empleado: key });
          if (datoOpEmp.length > 0) {
            await deleteDatoOperacionalDelEmpleado(datoOpEmp[0].id);
          }
          setVisibleAlert(false);
          onCancel();
          await fetchData(currentPage);
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = async (record) => {
    setSelectedRowKeys([record.id]);

    // Verificamos si el empleado tiene el estatus 4 (Autorizado) en cualquiera de sus estados
    const estaAutorizado = record.estado_del_empleado === 4
      || record.estados_globales === 4
      || record.estado_del_empleado === ESTATUS_AUTORIZADO
      || record.estados_globales === ESTATUS_AUTORIZADO;

    // Si el estatus es Autorizado, se bloquean los campos (gris).
    // Si es cualquier otro (Activo, Pre-Alta, En Proceso, etc.), se pueden editar.
    if (estaAutorizado) {
      setIsBlocked(true);
    } else {
      setIsBlocked(false);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };
  const onClickAdd = () => {
    onCancel();
    setCurrentParentTabKey('general');
    setCurrentTabKey('general');
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const seguimiento = useSeguimientoDeRegistro({
    contentTypeAppLabel: 'entidad',
    contentTypeModel: 'empleado',
    moduloDescripcion: 'Nómina',
    documentoOperativoDescripcion: 'Empleados',
    moduloOrigenLabel: 'Empleados',
    registros: fullData,
    seleccionIds: selectedRowKeys,
    registroActivo: open ? fullData.find((e) => e.id === selectedRowKeys[0]) || null : null,
    mutable: true,
    getRegistroLabel: (row) => `Empleado ${row.numero_de_empleado || row.id}`,
  });

  const columns = [
    {
      titleText: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
    },
    {
      titleText: 'Número de Empleado',
      dataIndex: 'numero_de_empleado',
      key: 'numero_de_empleado',
      width: 200,
    },
    // {
    //   titleText: 'Número de Empleado Anterior',
    //   dataIndex: 'numero_de_empleado_anterior',
    //   key: 'numero_de_empleado_anterior',
    //   width: 250,
    // },
    {
      titleText: 'Nombre',
      dataIndex: 'nombre',
      key: 'nombre',
      width: 250,
    },
    {
      titleText: 'Apellido Paterno',
      dataIndex: 'apellido_paterno',
      key: 'apellido_paterno',
      width: 250,
    },
    {
      titleText: 'Apellido Materno',
      dataIndex: 'apellido_materno',
      key: 'apellido_materno',
      width: 250,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'puesto_clave_y_descripcion',
      key: 'puesto_clave_y_descripcion',
      width: 200,
    },
    {
      titleText: 'Área',
      dataIndex: 'directorio_area_clave_y_nombre',
      key: 'directorio_area_clave_y_nombre',
      width: 250,
    },
    {
      titleText: 'No. de Plaza',
      dataIndex: 'plaza_clave_y_descripcion',
      key: 'plaza_clave_y_descripcion',
      width: 200,
    },
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'tipo_nomina_empleado',
      key: 'tipo_nomina_empleado',
      width: 250,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estado_del_empleado',
      key: 'estado_del_empleado',
      width: 200,
    },
    {
      titleText: 'Sueldo Diario',
      dataIndex: 'sueldo_diario',
      key: 'sueldo_diario',
      width: 150,
      render: (val) => (val ? currencyFormatter(val) : '-'),
    },
    {
      titleText: 'Sueldo Mensual',
      dataIndex: 'sueldo_mensual',
      key: 'sueldo_mensual',
      width: 180,
      render: (val) => (val ? currencyFormatter(val) : '-'),
    },
  ];

  const onClickExportarExcel = async () => {
    setLoading(true);
    const resultado = await getEmpleadosExportarCompleto();
    setLoading(false);
    if (!resultado) return;
    if (!resultado.filas.length) {
      message.info('No hay empleados para exportar.');
      return;
    }
    setDatosExportador(resultado.filas);
    setTitulosExportador(resultado.titulos);
    setShowExportador(true);
  };

  const menuExportar = (
    <Menu
      items={[
        {
          key: 1,
          label: 'Excel',
          text: 'Excel',
          icon: <FileExcelOutlined />,
          onClick: () => onClickExportarExcel(),
          disabledBySelection: false,
        },
        {
          key: 2,
          label: 'PDF',
          text: 'PDF',
          icon: <FilePdfOutlined />,
          disabledBySelection: false,
        },
      ]}
    />
  );

  const getControls = () => {
    if (isBlocked) {
      return {
        onClickAdd,
        onClickEdit: () => onClickEdit(),
        onClickDelete: () => onAlert(`El Tipo de Nómina Empleado ${nominaDisplay} se encuentra cerrado`),
      };
    }
    return {
      onClickAdd,
      onClickEdit: () => onClickEdit(),
      onClickDelete,
    };
  };

  // -----------------------------------------------------------------------
  // Historial SBC Empleado
  // -----------------------------------------------------------------------

  const loadHistorialSBC = async (empId) => {
    if (!empId) return;
    try {
      const result = await getHistoricoSBCEmpleado({ empleado: empId });
      setHistorialSBC(result?.results || result || []);
    } catch (err) {
      onError(err);
    }
  };

  useEffect(() => {
    if (currentTabKey === 'filiacion' && selectedRowKeys.length > 0) {
      loadHistorialSBC(selectedRowKeys[0]);
    } else if (!selectedRowKeys.length) {
      setHistorialSBC([]);
      setHistorialSBCSeleccionado(null);
      setSelectedHistorialSBCKeys([]);
    }
  }, [currentTabKey, selectedRowKeys]);

  const handleAddHistorialSBC = () => {
    setHistorialSBCSeleccionado(null);
    formHistorialSBC.resetFields();
    setVisibleHistorialSBCModal(true);
  };

  const handleEditHistorialSBC = () => {
    if (!historialSBCSeleccionado) return;
    formHistorialSBC.setFieldsValue({
      salario_base_cotizacion_imss: historialSBCSeleccionado.salario_base_cotizacion_imss,
      fecha_inicial: historialSBCSeleccionado.fecha_inicial
        ? moment(historialSBCSeleccionado.fecha_inicial) : null,
      fecha_final: historialSBCSeleccionado.fecha_final
        ? moment(historialSBCSeleccionado.fecha_final) : null,
    });
    setVisibleHistorialSBCModal(true);
  };

  const onFinishHistorialSBC = async () => {
    try {
      await formHistorialSBC.validateFields();
    } catch {
      return;
    }
    const values = formHistorialSBC.getFieldsValue();
    const empId = selectedRowKeys[0];
    const payload = {
      empleado: empId,
      salario_base_cotizacion_imss: values.salario_base_cotizacion_imss,
      fecha_inicial: values.fecha_inicial?.format('YYYY-MM-DD'),
      fecha_final: values.fecha_final?.format('YYYY-MM-DD') || null,
      estados_globales: 1,
    };
    setLoading(true);
    let ok;
    if (historialSBCSeleccionado) {
      ok = await patchHistoricoSBCEmpleado(historialSBCSeleccionado.id, payload);
    } else {
      ok = await postHistoricoSBCEmpleado(payload);
    }
    if (ok) {
      setVisibleHistorialSBCModal(false);
      formHistorialSBC.resetFields();
      setHistorialSBCSeleccionado(null);
      setSelectedHistorialSBCKeys([]);
      await loadHistorialSBC(empId);
    }
    setLoading(false);
  };

  const confirmDeleteHistorialSBC = async () => {
    if (!historialSBCSeleccionado) return;
    setLoading(true);
    const ok = await deleteHistoricoSBCEmpleado(historialSBCSeleccionado.id);
    if (ok) {
      setVisibleDeleteHistorialSBC(false);
      setHistorialSBCSeleccionado(null);
      setSelectedHistorialSBCKeys([]);
      await loadHistorialSBC(selectedRowKeys[0]);
    }
    setLoading(false);
  };

  const onConfirmAutorizarSBC = async () => {
    setLoading(true);
    const ok = await patchHistoricoSBCEmpleado(
      historialSBCSeleccionado.id,
      { estados_globales: ESTATUS_AUTORIZADO },
    );
    if (ok) {
      setVisibleConfirmAutorizarSBC(false);
      setHistorialSBCSeleccionado(null);
      setSelectedHistorialSBCKeys([]);
      await loadHistorialSBC(selectedRowKeys[0]);
    }
    setLoading(false);
  };

  const onConfirmCancelarSBC = async () => {
    setLoading(true);
    const ok = await patchHistoricoSBCEmpleado(
      historialSBCSeleccionado.id,
      { estados_globales: ESTATUS_CANCELADO },
    );
    if (ok) {
      setVisibleConfirmCancelarSBC(false);
      setHistorialSBCSeleccionado(null);
      setSelectedHistorialSBCKeys([]);
      await loadHistorialSBC(selectedRowKeys[0]);
    }
    setLoading(false);
  };

  const handleImportarSBC = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setLoading(true);
    try {
      const response = await importarSBCEmpleado(file);
      if (response?.data) {
        const blob = new Blob([response.data], { type: 'application/ms-excel' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'sbc_empleados_resultado.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        await loadHistorialSBC(selectedRowKeys[0]);
      }
    } catch (err) {
      onError(err);
    }
    setLoading(false);
    e.target.value = '';
  };

  const columnsSBC = [
    {
      titleText: 'SBC IMSS',
      dataIndex: 'salario_base_cotizacion_imss',
      key: 'salario_base_cotizacion_imss',
      width: 160,
      render: (val) => currencyFormatter(val),
    },
    {
      titleText: 'Fecha Inicial',
      dataIndex: 'fecha_inicial',
      key: 'fecha_inicial',
      width: 140,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    {
      titleText: 'Fecha Final',
      dataIndex: 'fecha_final',
      key: 'fecha_final',
      width: 140,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : 'Vigente'),
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales_descripcion',
      key: 'estados_globales_descripcion',
      width: 120,
    },
  ];

  const itemDireccionDefault = 'General';
  const itemsDireccion = [
    {
      key: itemDireccionDefault,
      label: itemDireccionDefault,
      children: <DireccionGeneral
        permission={permission}
        IdParent={empleadoId}
      />,
    },
    {
      key: 'Especifico',
      label: 'Especifico',
      children: <Direcciones
        formDireccion={formDireccion}
        rules={rules}
        coloniasCargadas={coloniasCargadas}
        paises={paises}
        isBlocked={isBlocked}
        permission={permission}
        empleadoId={empleadoId}
      />,
    },
  ];

  return (
    <Row className="container">
      {loading && (
        <div style={{ paddingBottom: 8 }}>
          ⏳ Cargando...
        </div>
      )}

      {!loading && loadingTime > 0 && (
        <div style={{ marginBottom: 8 }}>
          ✅ Datos cargados en
          {' '}
          {loadingTime}
          {' '}
          segundos | Registros cargados:
          {' '}
          {fullData.length}
        </div>
      )}
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          <>
            {seguimiento.conBarra(<Table
              data={fullData}
              pagination
              cols={[seguimiento.columnaSeguimiento, ...columns]}
              allowImport
              allowExtraImport
              asyncImport
              asyncImportExtra
              baseURI={baseURI}
              baseURIExtra={baseURIExtra}
              labelExtraImport="Datos Operativos"
              rowSelection={rowSelection}
              handleOnRowClick={handleOnRowClick}
              controls={getControls()}
              permission={permission}
              customExportMenu={menuExportar}
              allowCustomExport
              customActions={[
                seguimiento.accionSeguimiento,
                {
                  permission: { model: 'empleado', action: 'editarautorizado' },
                  onClick: () => {
                    setEditandoAutorizado(true);
                    setCurrentParentTabKey('general');
                    setCurrentTabKey('general');
                    onClickEdit();
                  },
                  text: 'Editar Autorizado',
                  icon: <EditOutlined />,
                  disabledBySelection: true,
                  disabled: !isBlocked,
                },
                {
                  permission: { model: 'empleado', action: 'change' },
                  onClick: () => setVisibleConfirmActualizarFotos(true),
                  text: 'Actualizar Fotografía',
                  icon: <CameraOutlined />,
                  disabledBySelection: false,
                  disabled: isPollingActualizarFotos,
                },
              ]}
            />)}
            <ExportadorExcelPersonalizado
              visible={showExportador}
              onCancel={() => setShowExportador(false)}
              data={datosExportador}
              titulosPorColumna={titulosExportador}
              // Las columnas cambiaron (ahora son todas las pestañas): configuraciones guardadas
              // propias, sin mezclarse con las que se hicieron con las columnas de la tabla.
              reporteId="todas-las-pestanas"
              fileName={`Empleados_${moment().format('YYYY-MM-DD')}`}
              sheetName="Empleados"
            />
          </>
        ) : (
          <Card
            className="form-container"
            title={(() => {
              let accion = 'Agregar';
              if (editandoAutorizado) accion = 'Editar Autorizado';
              else if (selectedRowKeys.length) accion = 'Editar';
              const nombre = selectedRowKeys.length
                ? ` "${numEmpleadoEditar} - ${nombreEmpleadoEditar} ${apellidoPEmpleadoEditar}${apellidoMEmpleadoEditar ? ` ${apellidoMEmpleadoEditar}` : ''}"`
                : '';
              return `${accion} Empleado${nombre}`;
            })()}
            extra={(
              <FormSubmitControls
                onFinish={onFinish}
                onCancel={onCancelWithFetch}
                loading={loading}
                onFinishText="Guardar y Continuar"
              />
            )}
            bordered={false}
          >
            {seguimiento.envolverConSeguimiento(
              <Tabs
                type="card"
                activeKey={currentParentTabKey || 'general'}
                onChange={setCurrentParentTabKey}
              >
                <TabPane
                  tab={(
                    <span>
                      <InfoCircleOutlined />
                      {' '}
                      Datos Generales
                    </span>
                )}
                  key="general"
                  forceRender
                >
                  <div>
                    <Tabs
                      activeKey={currentTabKey || 'general'}
                      onChange={setCurrentTabKey}
                      type="card"
                    >
                      <TabPane
                        tab={(
                          <span>
                            <InfoCircleOutlined />
                            {' '}
                            General
                          </span>
                      )}
                        key="general"
                        forceRender
                      >
                        <EmpleadoGeneral
                          form={form}
                          formFiliacion={formFiliacion}
                          rules={rules}
                          selectedRowKeys={selectedRowKeys}
                          paises={paises}
                          estados={estados}
                          generos={generos}
                          estadoCivil={estadoCivil}
                          estadosEmpleado={estadosEmpleado}
                          tiposDeMovimientoDePersonal={tiposDeMovimientoDePersonal}
                          nacionalidades={nacionalidades}
                          calcularEdad={calcularEdad}
                          disableEstatus={disableEstatus}
                          isBlocked={isBlocked && !editandoAutorizado}
                        />
                      </TabPane>
                      <TabPane
                        tab={(
                          <span>
                            <FileTextOutlined />
                            {' '}
                            Filiación
                          </span>
                      )}
                        key="filiacion"
                        forceRender
                        disabled={editandoAutorizado}
                      >
                        <EmpleadoFiliacion
                          form={form}
                          formFiliacion={formFiliacion}
                          tiposDeIdentificaciones={tiposDeIdentificaciones}
                          tiposDeSeguridadesSociales={tiposDeSeguridadesSociales}
                          registrosPatronales={registrosPatronales}
                          rules={rules}
                          codigosPostales={codigosPostales}
                          coloniasCargadas={coloniasCargadas}
                        />
                        <Divider orientation="left">Historial SBC IMSS</Divider>
                        <Table
                          titleTable="Historial SBC Empleado"
                          cols={columnsSBC}
                          data={historialSBC}
                          pagination={false}
                          rowSelection={{
                            selectedRowKeys: selectedHistorialSBCKeys,
                            onChange: (keys, rows) => {
                              setSelectedHistorialSBCKeys(keys);
                              setHistorialSBCSeleccionado(rows[0] || null);
                            },
                            type: 'radio',
                          }}
                          handleOnRowClick={(record) => {
                            setSelectedHistorialSBCKeys([record.id]);
                            setHistorialSBCSeleccionado(record);
                          }}
                          controls={{
                            onClickAdd: handleAddHistorialSBC,
                            onClickEdit: handleEditHistorialSBC,
                            onClickDelete: () => setVisibleDeleteHistorialSBC(true),
                          }}
                          customActions={[
                            {
                              permission: { model: 'historicosbcempleado', action: 'cancelar' },
                              onClick: () => historialSBCSeleccionado && setVisibleConfirmCancelarSBC(true),
                              text: 'Cancelar',
                              icon: <CloseCircleOutlined />,
                              disabledBySelection: false,
                              className: 'cancel',
                              disabled: !historialSBCSeleccionado
                              || historialSBCSeleccionado?.estados_globales === ESTATUS_CANCELADO,
                            },
                            {
                              permission: { model: 'historicosbcempleado', action: 'autorizar' },
                              onClick: () => historialSBCSeleccionado && setVisibleConfirmAutorizarSBC(true),
                              text: 'Autorizar',
                              icon: <CheckCircleOutlined />,
                              disabledBySelection: false,
                              className: 'success',
                              disabled: !historialSBCSeleccionado
                              || historialSBCSeleccionado?.estados_globales === ESTATUS_AUTORIZADO
                              || historialSBCSeleccionado?.estados_globales === ESTATUS_CANCELADO,
                            },
                          ]}
                          permission={permission}
                        />
                        <Divider orientation="left">Kárdex SBC Variable</Divider>
                        <KardexSBC
                          empleadoId={empleadoId}
                          permission={kardexSBCEmpleadoPermission_}
                        />
                      </TabPane>
                      <TabPane
                        tab={(
                          <span>
                            <EnvironmentOutlined />
                            {' '}
                            Dirección
                          </span>
                      )}
                        key="direccion"
                        forceRender
                        disabled={!selectedRowKeys.length || editandoAutorizado}
                      >
                        <Tabs
                          type="card"
                          defaultActiveKey={itemDireccionDefault}
                          items={itemsDireccion}
                        />
                      </TabPane>
                      <TabPane
                        tab={(
                          <span>
                            <FileTextOutlined />
                            {' '}
                            Estudios
                          </span>
                      )}
                        key="estudios"
                        forceRender
                        disabled={editandoAutorizado}
                      >
                        <EmpleadoEstudios
                          form={form}
                          rules={rules}
                          nivelesDeEstudios={nivelesDeEstudios}
                          abreviaturasDeCarreras={abreviaturasDeCarreras}
                          comprobantesDeEstudios={comprobantesDeEstudios}
                          especialidadesDeEstudios={especialidadesDeEstudios}
                          isBlocked={isBlocked}
                        />
                      </TabPane>
                      <TabPane
                        tab={(
                          <span>
                            <PhoneOutlined />
                            Contacto
                          </span>
                      )}
                        key="contacto"
                        forceRender
                        disabled={editandoAutorizado}
                      >
                        <EmpleadoContacto
                          form={form}
                          rules={rules}
                          nivelesDeEstudios={nivelesDeEstudios}
                          abreviaturasDeCarreras={abreviaturasDeCarreras}
                          comprobantesDeEstudios={comprobantesDeEstudios}
                          especialidadesDeEstudios={especialidadesDeEstudios}
                          isBlocked={isBlocked}
                          preferenciaPartidaria={preferenciaPartidaria}
                        />
                      </TabPane>
                      <TabPane
                        tab={(
                          <span>
                            Otros
                          </span>
                      )}
                        key="otros"
                        forceRender
                        disabled={!selectedRowKeys.length || editandoAutorizado}
                      >
                        <Otros
                          form={form}
                          rules={rules}
                          empleado_id={empleadoId}
                          permission={getPermission}
                          nivelesDeEstudios={nivelesDeEstudios}
                          abreviaturasDeCarreras={abreviaturasDeCarreras}
                          comprobantesDeEstudios={comprobantesDeEstudios}
                          especialidadesDeEstudios={especialidadesDeEstudios}
                          isBlocked={isBlocked}
                        />
                      </TabPane>
                    </Tabs>
                  </div>
                </TabPane>
                <TabPane
                  tab={(
                    <span>
                      <UserOutlined />
                      {' '}
                      Datos Operacionales
                    </span>
                )}
                  key="operativos"
                  forceRender
                  disabled={!selectedRowKeys.length || editandoAutorizado}
                >
                  <div>
                    <Tabs
                      activeKey={currentTabKeyDO || 'adscripcion'}
                      onChange={setCurrentTabKeyDO}
                      type="card"
                    >
                      <TabPane
                        tab={(
                          <span>
                            <CalendarOutlined />
                            {' '}
                            Adscripción
                          </span>
                      )}
                        key="adscripcion"
                        forceRender
                      >
                        <EmpleadoAdscripcion
                          form={formOperacionales}
                          rules={rules}
                          puestos={puestos}
                          formPlazas={formPlazas}
                          areas={areas}
                          categoriaDePuestos={categoriaDePuestos}
                          tiposEmpleados={tiposEmpleados}
                          tiposDeFunciones={tiposDeFunciones}
                          tabuladoresGenerales={tabuladoresGenerales}
                          calcularAntiguedad={calcularAntiguedad}
                          setFechaDeAlta={setFechaDeAlta}
                          setFechaDeBaja={setFechaDeBaja}
                          setFechaDeReingreso={setFechaDeReingreso}
                          isBlocked={isBlocked}
                          cuipHabilitado={cuipHabilitado}
                          setCuipHabilitado={setCuipHabilitado}
                          empleado={empleadoId}
                          nombramientosSinPaginar={nombramientosSinPaginar}
                          plazaEmpleado={plazaEmpleado}
                        />
                      </TabPane>
                      <TabPane
                        tab={(
                          <span>
                            <FileTextOutlined />
                            {' '}
                            Atributos
                          </span>
                      )}
                        key="atributos"
                        forceRender
                      >
                        <EmpleadoAtributos
                          form={formOperacionales}
                          formGeneral={form}
                          tipodeActividades={tipoDeActividad}
                          tiemposDeContrataciones={tiemposDeContrataciones}
                          tiposDeContrataciones={tiposDeContrataciones}
                          jornadas={jornadas}
                          tiposDeSueldos={tiposDeSueldos}
                          sindicatos={sindicatos}
                          perioricidadesDePago={periodicidadesDePagos}
                          zonasDeSalariosMinimos={zonasDeSalariosMinimos}
                          tiposRegimenesNominas={tiposRegimenesNominas}
                          tiposDeNominasEmpleados={tiposDeNominasEmpleados}
                          rules={rules}
                          isBlocked={isBlocked}
                          caracteresDeNombramiento={caracteresDeNombramiento}
                          empleado={empleadoId}
                          nombramientosSinPaginar={nombramientosSinPaginar}
                          plazaEmpleado={plazaEmpleado}
                          tiposEmpleados={tiposEmpleados}
                          tiposOrigenesContratacion={tiposOrigenesContratacion}
                          origenContratacionSeleccionado={origenContratacionSeleccionado}
                        />
                      </TabPane>
                      <TabPane
                        tab={(
                          <span>
                            <DollarOutlined />
                            {' '}
                            Datos Presupuestales
                          </span>
                      )}
                        key="datos_presupuestales"
                        forceRender
                      >
                        <EmpleadoDatosPresupuestales
                          form={formOperacionales}
                          rules={rules}
                          isBlocked={isBlocked}
                          empleado={empleadoId}
                        />
                      </TabPane>
                    </Tabs>
                  </div>
                </TabPane>
                <TabPane
                  tab={(
                    <span>
                      <CreditCardOutlined />
                      {' '}
                      Formas de pago
                    </span>
                )}
                  key="pago"
                  forceRender
                  disabled={!selectedRowKeys.length || editandoAutorizado}
                >
                  <EmpleadoFormaPago
                    form={formPago}
                    permission={getPermission}
                    empleado_id={empleadoId}
                    rules={rules}
                    metodosDePagos={metodosDePagos}
                    bancos={bancos}
                    tiposDeDepositos={tiposDeDepositos}
                  />
                </TabPane>
                <TabPane
                  tab={(
                    <span>
                      <TeamOutlined />
                      {' '}
                      Sindicato
                    </span>
                )}
                  key="sindicato"
                  forceRender
                  disabled={!selectedRowKeys.length || editandoAutorizado}
                >
                  <Sindicato
                    permission={sindicatoPermission}
                    empleadoId={empleadoId}
                    sindicatos={sindicatos}
                    rules={rules}
                    isBlocked={isBlocked}
                    formOperacionales={formOperacionales}
                  />
                </TabPane>
                <TabPane
                  tab={(
                    <span>
                      <AuditOutlined />
                      {' '}
                      Nombramientos
                    </span>
                  )}
                  key="nombramientos"
                  forceRender
                  disabled={!selectedRowKeys.length || editandoAutorizado}
                >
                  <NombramientosEmpleado
                    permission={nombramientosEmpleadoPermission_}
                    empleadoId={empleadoId}
                  />
                </TabPane>
                <TabPane
                  tab={(
                    <span>
                      <SolutionOutlined />
                      {' '}
                      Documentos
                    </span>
                )}
                  key="documentos"
                  forceRender
                  disabled={!selectedRowKeys.length || editandoAutorizado}
                >
                  <Documentos
                    permission={getPermission}
                    empleadoId={empleadoId}
                    formEmpleado={form}
                    rules={rules}
                    isBlocked={isBlocked}
                    actualizarTablaEmpleados={fetchData}
                  />
                </TabPane>
              </Tabs>,
              'este Empleado',
            )}
          </Card>
        )}
        {seguimiento.modalSeguimiento}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Empleado ${form.getFieldValue('nombre')} ${form.getFieldValue('apellido_paterno')}`}
          loading={loading}
        />
        {/* Historial SBC Empleado modals */}
        <Modal
          open={visibleHistorialSBCModal}
          title={(
            <FormSubmitControls
              label={historialSBCSeleccionado ? 'Editar SBC' : 'Agregar SBC'}
              onFinish={onFinishHistorialSBC}
              onCancel={() => {
                setVisibleHistorialSBCModal(false);
                formHistorialSBC.resetFields();
              }}
              loading={loading}
            />
          )}
          footer={null}
          onCancel={() => {
            setVisibleHistorialSBCModal(false);
            formHistorialSBC.resetFields();
          }}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          destroyOnClose
        >
          <Form
            form={formHistorialSBC}
            layout="vertical"
            onFinish={onFinishHistorialSBC}
          >
            <Row gutter={16}>
              <Col xs={24} sm={24}>
                <CurrencyInput
                  name="salario_base_cotizacion_imss"
                  label="Salario Base de Cotización IMSS"
                  rules={[{ required: true, message: 'Requerido' }]}
                />
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  name="fecha_inicial"
                  label="Fecha Inicial"
                  rules={[{ required: true, message: 'Requerido' }]}
                >
                  <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  name="fecha_final"
                  label="Fecha Final (vacío = vigente)"
                >
                  <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item hidden>
              <Button htmlType="submit" />
            </Form.Item>
          </Form>
        </Modal>
        <ModalDelete
          open={visibleDeleteHistorialSBC}
          onCancel={() => setVisibleDeleteHistorialSBC(false)}
          onDelete={confirmDeleteHistorialSBC}
          content={`el registro SBC del ${historialSBCSeleccionado?.fecha_inicial || ''}`}
          loading={loading}
        />
        <ModalConfirmation
          open={visibleConfirmAutorizarSBC}
          onFinish={onConfirmAutorizarSBC}
          ConfirmAutorize
          onCancel={() => setVisibleConfirmAutorizarSBC(false)}
          contentTitle={`Autorizar el SBC vigente desde ${historialSBCSeleccionado?.fecha_inicial || ''}`}
          loading={loading}
        />
        <ModalConfirmation
          open={visibleConfirmCancelarSBC}
          onFinish={onConfirmCancelarSBC}
          Confirm
          onCancel={() => setVisibleConfirmCancelarSBC(false)}
          contentTitle={`Cancelar el SBC vigente desde ${historialSBCSeleccionado?.fecha_inicial || ''}`}
          loading={loading}
        />
        <ModalConfirmation
          open={visibleConfirmActualizarFotos}
          onFinish={onConfirmActualizarFotos}
          Confirm
          onCancel={() => setVisibleConfirmActualizarFotos(false)}
          contentTitle="actualizar la fotografía de los empleados que aún no tienen una registrada"
          loading={isPollingActualizarFotos}
          extraContent={(
            <p style={{ marginTop: 8 }}>
              Se descargará la fotografía únicamente para los
              empleados sin fotografía. Este proceso puede tardar varios minutos.
            </p>
          )}
        />
        <Modal
          open={isPollingActualizarFotos && !minimizadoFotos}
          title="Actualizando Fotografías"
          footer={(
            <>
              <Button onClick={() => setMinimizadoFotos(true)}>
                Minimizar
              </Button>
              <Button
                danger
                onClick={onClickDetenerActualizarFotos}
                loading={loadingDetenerFotos}
              >
                Detener
              </Button>
            </>
          )}
          closable={false}
          maskClosable={false}
          centered
        >
          <div style={{ textAlign: 'center', padding: '16px 0' }}>
            <Progress
              type="circle"
              percent={
                progresoActualizarFotos.total > 0
                  ? Math.round(
                    (progresoActualizarFotos.en_curso / progresoActualizarFotos.total) * 100,
                  )
                  : 0
              }
            />
            <p style={{ marginTop: 16 }}>
              {progresoActualizarFotos.total > 0
                ? `${progresoActualizarFotos.en_curso} / ${progresoActualizarFotos.total} empleados procesados`
                : 'Iniciando actualización de fotografías...'}
            </p>
          </div>
        </Modal>
        {isPollingActualizarFotos && minimizadoFotos && (
          <div
            role="button"
            tabIndex={0}
            onClick={() => setMinimizadoFotos(false)}
            onKeyDown={(e) => e.key === 'Enter' && setMinimizadoFotos(false)}
            style={{
              position: 'fixed',
              bottom: 24,
              right: 24,
              zIndex: 1000,
              background: '#fff',
              borderRadius: 8,
              boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
              padding: '10px 16px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 12,
            }}
          >
            <Progress
              type="circle"
              width={40}
              percent={
                progresoActualizarFotos.total > 0
                  ? Math.round(
                    (progresoActualizarFotos.en_curso / progresoActualizarFotos.total) * 100,
                  )
                  : 0
              }
            />
            <span style={{ fontSize: 13 }}>
              Actualizando fotografías
              {progresoActualizarFotos.total > 0 && (
                <>
                  {' — '}
                  {progresoActualizarFotos.en_curso}
                  /
                  {progresoActualizarFotos.total}
                </>
              )}
            </span>
          </div>
        )}
      </Spin>
    </Row>
  );
};

export default Empleados;
